import React from "react";
import "./BrandLoader.css";

const BrandLoader = ({ label = "Loading Maulshree...", fullScreen = false }) => {
  return (
    <div className={fullScreen ? "brand-loader-overlay" : "brand-loader-inline"}>
      <div className="brand-loader-mark">
        <span className="brand-loader-ring" />
        <img
          src="/SVG/diamond-rich_teal.svg"
          alt=""
          className="brand-loader-diamond"
        />
      </div>
      {label && <p className="brand-loader-text">{label}</p>}
    </div>
  );
};

export default BrandLoader;
